// @flow

export default class Analytics {
  static trackEvent(event: string, eventProps: Object, callback?: () => void) {
    if (window.analytics) {
      window.analytics.track(event, eventProps, {}, callback);
    }
  }
}
